<template>
  <div id="ag-grid-lists">
    <div id="div-with-loading" class="vs-con-loading__container">
      <!-- Tabs on the top -->
      <vs-tabs class="updates-page custom-vs-tabs">
        <vs-tab label="CNIC Promos" v-if="!disableCNICFlag">
          <div class="tab-text">
            <vs-collapse>
              <vs-collapse-item ref="vsCollapseItem" class="expiring-week-header" open>
                <div slot="header">
                  Expiring This Week
                </div>
                <CNICPromosExpiringInAWeek></CNICPromosExpiringInAWeek>
              </vs-collapse-item>
              <vs-collapse-item ref="vsCollapseItem" class="expiring-month-header" open>
                <div slot="header">
                  Expiring This Month
                </div>
                <CNICPromosExpiringInAMonth></CNICPromosExpiringInAMonth>
              </vs-collapse-item>

              <vs-collapse-item ref="vsCollapseItem" class="expired-header" open>
                <div slot="header">Expired</div>
                <CNICPromosExpired></CNICPromosExpired>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vs-tab>

        <vs-tab label="Tucows Promos">
          <div class="tab-text">
            <vs-collapse>
              <vs-collapse-item ref="vsCollapseItem" class="expiring-week-header" open>
                <div slot="header">
                  Expiring This Week
                </div>
                <TucowsPromosExpiringInAWeek></TucowsPromosExpiringInAWeek>
              </vs-collapse-item>
              <vs-collapse-item ref="vsCollapseItem" class="expiring-month-header" open>
                <div slot="header">
                  Expiring This Month
                </div>
                <TucowsPromosExpiringInAMonth></TucowsPromosExpiringInAMonth>
              </vs-collapse-item>

              <vs-collapse-item ref="vsCollapseItem" class="expired-header" open>
                <div slot="header">Expired</div>
                <TucowsPromosExpired></TucowsPromosExpired>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vs-tab>

        <vs-tab label="Internal Promos">
          <div class="tab-text">
            <vs-collapse>
              <vs-collapse-item ref="vsCollapseItem" class="expiring-week-header" open>
                <div slot="header">
                  Expiring This Week
                </div>
                <InternalPromosExpiringInAWeek></InternalPromosExpiringInAWeek>
              </vs-collapse-item>

              <vs-collapse-item ref="vsCollapseItem" class="expiring-month-header" open>
                <div slot="header">
                  Expiring This Month
                </div>
                <InternalPromosExpiringInAMonth></InternalPromosExpiringInAMonth>
              </vs-collapse-item>

              <vs-collapse-item ref="vsCollapseItem" class="expired-header" open>
                <div slot="header">Expired</div>
                <InternalPromosExpired></InternalPromosExpired>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vs-tab>

        <vs-tab label="MIS">
          <div class="tab-text">
            <vs-collapse>
              <vs-collapse-item ref="vsCollapseItem" class="expiring-week-header" open>
                <div slot="header">
                  Expiring This Week
                </div>
                <MISExpiringInAWeek></MISExpiringInAWeek>
              </vs-collapse-item>

              <vs-collapse-item ref="vsCollapseItem" class="expiring-month-header" open>
                <div slot="header">
                  Expiring This Month
                </div>
                <MISExpiringInAMonth></MISExpiringInAMonth>
              </vs-collapse-item>

              <vs-collapse-item ref="vsCollapseItem" class="expired-header" open>
                <div slot="header">Expired</div>
                <MISExpired></MISExpired>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
    <EditCnicPromo></EditCnicPromo>

    <EditInternalPromo></EditInternalPromo>

    <EditMISPromo></EditMISPromo>
  </div>
</template>

<script>
import CnicPromoRequestComponent from "@/components/ag-grid-tables/promos/CnicPromoRequestComponent.vue";
import TucowsPromoRequestComponent from "@/components/ag-grid-tables/promos/TucowsPromoRequestComponent.vue";
import InternalPromoRequestComponent from "@/components/ag-grid-tables/promos/InternalPromoRequestComponent.vue";
import MisPromoRequestComponent from "@/components/ag-grid-tables/promos/MisPromoRequestComponent.vue";

import CNICPromosExpiringInAWeek from "@/components/ag-grid-tables/promos/CNICPromosExpiringInAWeek.vue";
import CNICPromosExpiringInAMonth from "@/components/ag-grid-tables/promos/CNICPromosExpiringInAMonth.vue";
import CNICPromosExpired from "@/components/ag-grid-tables/promos/CNICPromosExpired.vue";

import TucowsPromosExpiringInAWeek from "@/components/ag-grid-tables/promos/TucowsPromosExpiringInAWeek.vue";
import TucowsPromosExpiringInAMonth from "@/components/ag-grid-tables/promos/TucowsPromosExpiringInAMonth.vue";
import TucowsPromosExpired from "@/components/ag-grid-tables/promos/TucowsPromosExpired.vue";

import InternalPromosExpiringInAWeek from "@/components/ag-grid-tables/promos/InternalPromosExpiringInAWeek.vue";
import InternalPromosExpiringInAMonth from "@/components/ag-grid-tables/promos/InternalPromosExpiringInAMonth.vue";
import InternalPromosExpired from "@/components/ag-grid-tables/promos/InternalPromosExpired.vue";

import MISExpiringInAWeek from "@/components/ag-grid-tables/promos/MISExpiringInAWeek.vue";
import MISExpiringInAMonth from "@/components/ag-grid-tables/promos/MISExpiringInAMonth.vue";
import MISExpired from "@/components/ag-grid-tables/promos/MISExpired.vue";

import EditCnicPromo from "@/components/ag-grid-tables/promos/EditCNICPromo.vue";
import EditInternalPromo from "@/components/ag-grid-tables/promos/EditInternalPromo.vue";
import EditMISPromo from "@/components/ag-grid-tables/promos/EditMISPromo.vue";

export default {
  name: 'PromoUpdates',
  components: {
    CnicPromoRequestComponent,
    TucowsPromoRequestComponent,
    InternalPromoRequestComponent,
    MisPromoRequestComponent,
    CNICPromosExpiringInAWeek,
    CNICPromosExpiringInAMonth,
    CNICPromosExpired,
    TucowsPromosExpiringInAWeek,
    TucowsPromosExpiringInAMonth,
    TucowsPromosExpired,
    InternalPromosExpiringInAWeek,
    InternalPromosExpiringInAMonth,
    InternalPromosExpired,
    MISExpiringInAWeek,
    MISExpiringInAMonth,
    MISExpired,
    EditCnicPromo,
    EditInternalPromo,
    EditMISPromo,
  },
  computed: {
    disableCNICFlag() {
			return this.$store.getters.getDisableCNICFlag;
		}
  }
};
</script>

<style scoped>

</style>